import * as sharedActions from './actions';

import { DetailsSharedActionTypes, DetailsSharedState } from './types';

import { ActionType } from 'typesafe-actions';
import { DetailsSharedActionPage } from './model';
import { Reducer } from 'redux';

export type SharedAction = ActionType<typeof sharedActions>;

const initialState: DetailsSharedState = {
  pages: [
    DetailsSharedActionPage.AGENDA,
    DetailsSharedActionPage.INSURED_PERSON,
    DetailsSharedActionPage.POLICY,
    DetailsSharedActionPage.CASE,
    DetailsSharedActionPage.EXPERTISE_ATTACHMENT,
    DetailsSharedActionPage.RIM,
    DetailsSharedActionPage.SVS,
    DetailsSharedActionPage.IMAGES,
    DetailsSharedActionPage.OTHER_ATTACHMENTS,
    DetailsSharedActionPage.COMMENT_OR_REPORT,
    DetailsSharedActionPage.HONORARY_NOTE,
    DetailsSharedActionPage.OVERVIEW,
  ],
  previousPage: DetailsSharedActionPage.INSURED_PERSON,
  currentPage: DetailsSharedActionPage.INSURED_PERSON
};

const reducer: Reducer<DetailsSharedState, SharedAction> = (state = initialState, action): DetailsSharedState => {
  switch (action.type) {
    case DetailsSharedActionTypes.CHANGE_ACTION_PAGE_SUCCESS: {
      if (action.payload !== undefined) {
        return { ...state, currentPage: action.payload, previousPage: state.currentPage };
      }
      return state;
    }
    case DetailsSharedActionTypes.RESET_SELECTED_PAGE: {
      return { ...state, currentPage: DetailsSharedActionPage.INSURED_PERSON };
    }
    default:
      return state;
  }
};

export { reducer as detailsSharedReducer, initialState as detailsSharedInitialState };
